import * as v from "valibot";

import { rpcContract } from "../rpc";

const telemetrySnapshotSchema = v.object({
  session_id: v.string(),
  stream_id: v.string(),
  timestamp: v.number(),
  bitrate: v.number(),
  packets_lost: v.number(),
  packets_received: v.number(),
  packet_loss_rate: v.number(),
  jitter: v.number(),
  frames_decoded: v.number(),
  frames_dropped: v.number(),
  frames_received: v.number(),
  frame_width: v.number(),
  frame_height: v.number(),
  frames_per_second: v.number(),
  current_rtt: v.number(),
  time_since_last_frame: v.number(),
  freeze_detected: v.boolean(),
  audio_packets_lost: v.optional(v.number()),
  audio_packets_received: v.optional(v.number()),
  operating_system: v.optional(v.string()),
  browser: v.optional(v.string()),
  browser_version: v.optional(v.string()),
  device_type: v.optional(v.string()),
  device_name: v.optional(v.string()),
});

export const ingestTelemetryRpcContract = rpcContract({
  name: "ingest-telemetry" as const,
  paramsSchema: v.object({
    snapshots: v.array(telemetrySnapshotSchema),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    inserted: v.number(),
  }),
});

export type IngestTelemetryParams = v.InferOutput<(typeof ingestTelemetryRpcContract)["paramsSchema"]>;
export type IngestTelemetryResult = v.InferOutput<(typeof ingestTelemetryRpcContract)["resultSchema"]>;
